import { render, staticRenderFns } from "./tianjiaoScoreList.vue?vue&type=template&id=06514141&scoped=true&"
import script from "./tianjiaoScoreList.vue?vue&type=script&lang=js&"
export * from "./tianjiaoScoreList.vue?vue&type=script&lang=js&"
import style0 from "./tianjiaoScoreList.vue?vue&type=style&index=0&id=06514141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06514141",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06514141')) {
      api.createRecord('06514141', component.options)
    } else {
      api.reload('06514141', component.options)
    }
    module.hot.accept("./tianjiaoScoreList.vue?vue&type=template&id=06514141&scoped=true&", function () {
      api.rerender('06514141', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/tianjiaoScoreManagement/tianjiaoScoreList.vue"
export default component.exports